export default __webpack_public_path__ + "static/media/pm22-top.c64d6ae8.png";